import { Status } from '../../components/Status'
import { ContractCategoryStatus } from './types'
import { CATEGORY_STATUS_NAME, CATEGORY_STATUS_TO_CLASSNAME } from './constants'

export const getStatus = (status: ContractCategoryStatus) => (
  <Status.Default className={CATEGORY_STATUS_TO_CLASSNAME[status]}>
    {CATEGORY_STATUS_NAME[status]}
  </Status.Default>
)
